import React from 'react';

const Status = (props) => {
    let { labels, globalTotalAnswered, minutes } = props;

    return(
        <div className="m-portlet m-portlet--bordered m-portlet--rounded  m-portlet--last">
            <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                        <h3 className="mr-5">
                            { labels.TotalContestadas }
                            <span className="focus-data badge bg-secondary ml-2">
                                { globalTotalAnswered } / { labels.TotalPreguntas }
                            </span>
                        </h3>
                        <h3>
                            { labels.Tiempo }
                            <span className="focus-data badge bg-secondary ml-2">
                                { minutes } / { labels.Duracion }
                            </span>
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Status;
